export const AUTO_IMPORT_PRODUCTS = [
  {
    productName: "PBIN-S",
    productTypeGuid: "d7a4437f-fde9-48cb-bd72-622756c795c2",
  },
  {
    productName: "PBIN-R",
    productTypeGuid: "390a999d-0294-434f-8882-d691d6cb9041",
  },
];
